'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _luxon = require('luxon');

var _lodash = require('lodash.omit');

var _lodash2 = _interopRequireDefault(_lodash);

var _Dropdown = require('../Dropdown/Dropdown');

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _DropdownContext = require('../Dropdown/DropdownContext');

var _DropdownContext2 = _interopRequireDefault(_DropdownContext);

var _DropdownMenu = require('../Dropdown/DropdownMenu');

var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);

var _DropdownMenuItem = require('../Dropdown/DropdownMenuItem');

var _DropdownMenuItem2 = _interopRequireDefault(_DropdownMenuItem);

var _DropdownSource = require('../Dropdown/DropdownSource');

var _DropdownSource2 = _interopRequireDefault(_DropdownSource);

var _DropdownTarget = require('../Dropdown/DropdownTarget');

var _DropdownTarget2 = _interopRequireDefault(_DropdownTarget);

var _Grid = require('../Grid/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _GridCell = require('../Grid/GridCell');

var _GridCell2 = _interopRequireDefault(_GridCell);

var _TextInput = require('../Form/TextInput');

var _TextInput2 = _interopRequireDefault(_TextInput);

var _TextInputIcon = require('../Form/TextInputIcon');

var _TextInputIcon2 = _interopRequireDefault(_TextInputIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var validTimeUnits = ['seconds', 'minutes', 'hours', 'days', 'weeks', 'months', 'years'];

var getStateFromIsoDurationValue = function getStateFromIsoDurationValue(value) {
  var duration = _luxon.Duration.fromISO(value);

  if (!duration.isValid) {
    return {};
  }

  var selectedUnit = [].concat(validTimeUnits).reverse().find(function (timeUnit) {
    return duration.values[timeUnit];
  });
  var selectedValue = duration.values[selectedUnit];

  return {
    selectedUnit: selectedUnit,
    selectedValue: selectedValue,
    value: value
  };
};

var getIsoDurationValueFromState = function getIsoDurationValueFromState(state) {
  var selectedUnit = state.selectedUnit,
      selectedValue = state.selectedValue;


  if (!validTimeUnits.includes(selectedUnit) || !selectedValue) {
    return '';
  }

  var duration = _luxon.Duration.fromObject(_defineProperty({}, selectedUnit, selectedValue));

  return duration.toISO();
};

var formatTimeUnit = function formatTimeUnit(timeUnit) {
  return '' + timeUnit.slice(0, 1).toUpperCase() + timeUnit.slice(1);
};

var DurationPicker = function (_Component) {
  _inherits(DurationPicker, _Component);

  function DurationPicker(props) {
    _classCallCheck(this, DurationPicker);

    var _this = _possibleConstructorReturn(this, (DurationPicker.__proto__ || Object.getPrototypeOf(DurationPicker)).call(this, props));

    _this.onBlur = _this.onBlur.bind(_this);
    _this.onChangeValue = _this.onChangeValue.bind(_this);
    _this.onChangeUnit = _this.onChangeUnit.bind(_this);
    _this.onChange = _this.onChange.bind(_this);

    _this.state = getStateFromIsoDurationValue(props.value);
    return _this;
  }

  _createClass(DurationPicker, [{
    key: 'onBlur',
    value: function onBlur() {
      this.props.onBlur();
    }
  }, {
    key: 'onChangeValue',
    value: function onChangeValue(event) {
      var inputValue = parseInt(event.target.value, 10);
      var selectedValue = Number.isFinite(inputValue) && inputValue >= 1 ? inputValue : '';
      var durationValue = getIsoDurationValueFromState({
        selectedUnit: this.state.selectedUnit,
        selectedValue: selectedValue
      });

      this.setState({
        selectedValue: selectedValue,
        value: durationValue
      }, this.onChange);
    }
  }, {
    key: 'onChangeUnit',
    value: function onChangeUnit(selectedUnit) {
      var durationValue = getIsoDurationValueFromState({
        selectedUnit: selectedUnit,
        selectedValue: this.state.selectedValue
      });

      this.setState({
        selectedUnit: selectedUnit,
        value: durationValue
      }, this.onChange);
    }
  }, {
    key: 'onChange',
    value: function onChange() {
      this.props.onChange(this.state.value);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value) {
        this.setState(getStateFromIsoDurationValue(this.props.value), this.onChange);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var excludedOptions = this.props.excludedOptions;

      var childProps = (0, _lodash2.default)(this.props, Object.keys(DurationPicker.propTypes));
      var filteredTimeUnits = validTimeUnits.filter(function (timeUnit) {
        return !excludedOptions.includes(timeUnit);
      });

      var _state = this.state,
          _state$selectedUnit = _state.selectedUnit,
          selectedUnit = _state$selectedUnit === undefined ? filteredTimeUnits[0] : _state$selectedUnit,
          _state$selectedValue = _state.selectedValue,
          selectedValue = _state$selectedValue === undefined ? '' : _state$selectedValue;


      return _react2.default.createElement(
        _Grid2.default,
        {
          fit: true,
          gutters: 'tiny',
          responsive: false,
          space: 'x0' },
        _react2.default.createElement(
          _GridCell2.default,
          null,
          _react2.default.createElement(_TextInput2.default, _extends({}, childProps, {
            onBlur: this.onBlur,
            onChange: this.onChangeValue,
            type: 'number',
            value: '' + selectedValue }))
        ),
        _react2.default.createElement(
          _GridCell2.default,
          null,
          _react2.default.createElement(
            _Dropdown2.default,
            {
              onRequestClose: this.onBlur },
            _react2.default.createElement(
              _DropdownTarget2.default,
              null,
              _react2.default.createElement(
                _TextInput2.default,
                _extends({}, childProps, {
                  isTarget: true,
                  readOnly: true,
                  value: formatTimeUnit(selectedUnit) }),
                _react2.default.createElement(_TextInputIcon2.default, {
                  name: 'chevron-down' })
              )
            ),
            _react2.default.createElement(
              _DropdownSource2.default,
              null,
              _react2.default.createElement(
                _DropdownContext2.default,
                null,
                _react2.default.createElement(
                  _DropdownMenu2.default,
                  null,
                  filteredTimeUnits.map(function (timeUnit) {
                    return _react2.default.createElement(
                      _DropdownMenuItem2.default,
                      {
                        key: timeUnit,
                        onClick: function onClick() {
                          return _this2.onChangeUnit(timeUnit);
                        },
                        selected: timeUnit === selectedUnit },
                      formatTimeUnit(timeUnit)
                    );
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return DurationPicker;
}(_react.Component);

DurationPicker.propTypes = {
  /** Excluded time-unit options */
  excludedOptions: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(validTimeUnits)),
  /** Invoked when value or unit field has been blurred */
  onBlur: _propTypes2.default.func,
  /** Invoked with the computed ISO duration value */
  onChange: _propTypes2.default.func,
  /** Valid ISO duration value (see https://en.wikipedia.org/wiki/ISO_8601#Durations) [DISABLED] */
  value: _propTypes2.default.string
};
DurationPicker.defaultProps = {
  excludedOptions: ['seconds'],
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  value: 'P7D'
};
exports.default = DurationPicker;